<template>
	<el-input
		:value="value"
		type="textarea"
		v-bind="$attrs"
		v-on="$listeners"
		@input="handleInput"
		:maxlength="maxLength"
	/>
</template>

<script>
export default {
	name: "CbsTextarea",
	inheritAttrs: false,
	props: {
		value: {
			required: true
		},
		maxLength: {
			type: Number,
			default: 1024
		}
	},
	methods: {
		handleInput(val) {
			this.$emit("input", val);
		}
	}
};
</script>
